import React, { useRef, useEffect } from "react";
import classNames from "classnames";
import "./Dropdown.scss";

const Dropdown = (props) => {
  let mainClassName = classNames({
    "dropdown-content": true,
    show: props.isExpanded,
  });

  const divRef = useRef(null);

  useEffect(() => {
    if (!!props.onRef) {
      props.onRef(divRef);
    }
  }, []);

  return (
    <div className={mainClassName} ref={divRef}>
      {props.children}
    </div>
  );
};

export default Dropdown;
